import * as React from "react";
import ReactTable from "react-table";
import {Documento, FiltroDocumento} from "../modelo/Documento";
import ModalDocumentos from "./ModalDocumentos";
import {REQUEST} from "../../../config/ajax-wrapper";
import {Mensaje} from "../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";
import { TIPO_GESTION } from "../modelo/TipoGestion";

export default class TablaDocumentos extends React.Component<TablaDocumentosProps> {

    columns = [{
        Header: "Identificación",
        accessor: "afiliado.identificacion",
    }, {
        Header: "Nombre Legal",
        accessor: "afiliado.nombreLegal",
    }, {
        Header: "Nombre Comercial",
        accessor: "afiliado.nombreComercial",
    }, {
        Header: "Fecha Radicación",
        accessor: "fechaRadicacion",
    }, {
        Header: "Estado",
        accessor: "estado"
    }, {
        Header: "Tipo Cliente",
        accessor: "tipoCliente.nombre",
    },{
        Header: "Contrato",
        accessor: "poliza",
        show: (this.props.tipoGestion === TIPO_GESTION.DOCUMENTOS_AFILIACION_COMERCIAL)
    }, {
        Header: "Asignado a",
        accessor: "usuarioAprueba",
    }
    , {
        Header: "Fecha asignacion",
        accessor: "fechaAsignacion",
    },{
        Header: "Tipo de Tramite",
        accessor: "tipoTramite",
        show: (this.props.tipoGestion === TIPO_GESTION.DOCUMENTOS_AFILIACION_DIRECTA)
    }, {
        Header: "Ver",
        accessor: "documentos",
        Cell: props => (
            <div className={"text-center"}>
                <ModalDocumentos 
                    dni={props.original.afiliado.identificacion}
                    documentosP8={props.value}
                    tipoCliente={props.original.tipoCliente}
                    nombreLegal={props.original.afiliado.nombreLegal}
                    canalComercial={props.original.canalComercial}
                    poliza={props.original.poliza}
                />
            </div>
        ),
    }];

    render() {
        const {documentos, estado, paginas, tamanoPagina, paginaActual, filtroDocumento} = this.props;
        const documentosConVerificacionDeCanal = documentos.map(doc =>{
            return {...doc, canalComercial: filtroDocumento.canalComercial};
        });
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error reintentando la tarea."}/>;
            case REQUEST.PENDING:
                return <DotLoader size={25}/>;
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                                 mensaje={"La tarea se ha enviado para su procesamiento exitosamente."}/>
                        {this.renderDocumentos(documentosConVerificacionDeCanal, paginas, tamanoPagina, paginaActual)}
                    </span>
                );
            default:
                return this.renderDocumentos(documentosConVerificacionDeCanal, paginas, tamanoPagina, paginaActual);
        }
    }

    renderDocumentos(documentos: Array<Documento>, paginas: number, tamanoPagina: number, paginaActual: number) {
        let numRegistros = 0;

        if (documentos.length < tamanoPagina) {
            numRegistros = documentos.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{documentos.length}</span> Documentos encontrados
                    </h2>
                </div>
                <ReactTable data={documentos}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            sortable={false}
                            resizable={false}
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroDocumento = {
            dni: this.props.filtroDocumento.dni,
            tipoCliente: this.props.filtroDocumento.tipoCliente,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex,
            fechaInicio: this.props.filtroDocumento.fechaInicio,
            fechaFin: this.props.filtroDocumento.fechaFin,
            tipoTramite: this.props.filtroDocumento.tipoTramite,
            canalComercial: this.props.filtroDocumento.canalComercial,
            poliza: this.props.filtroDocumento.poliza
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina : number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if( elemento ) {
            return arreglo;
        } else {
            return [...arreglo,tamanoPagina].sort( (a, b) => {return a-b;} );
        }
     }
}

interface TablaDocumentosProps {
    documentos: Array<Documento>
    estado: REQUEST,
    filtroDocumento: FiltroDocumento,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    tipoGestion: TIPO_GESTION,
    consultaPaginada?: (filtroDocumento: FiltroDocumento) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/TablaDocumentos.tsx